import styles from './Loader.module.css';

export const Loader = () => (
  <div className={styles.container}>
    <span className={styles.loader}></span>
  </div>
);
